import filter from './filter';
/**
 * @returns {function}
 */

function keep() {
  return filter(function (x) {
    return x !== null && x !== undefined;
  });
}

export default keep;